import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import Link from 'next/link'
import {UserContext, UserDispatcherContext} from "@providers/user";
import ButtonTransparent from "@atoms/button.transparent";
import RadiusGenerate from "@helpers/radius.generate";
import Icon from "@atoms/icon";
import ConvertPixelToRem from "@helpers/convert.rem";
import {isEmpty, str_replace} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import MyPropertyIcon from '@icons/menu/menu-my-property.svg';
import BookmarkIcon from '@icons/menu/menu-bookmark.svg';
import KeyIcon from '@icons/menu/menu-key.svg';
import VillaIcon from '@icons/villa.svg';
import RentIcon from '@icons/menu/menu-rent.svg';
import PeopleIcon from '@icons/menu/menu-people.svg';
import ExitIcon from '@icons/menu/menu-exit.svg';
import BookOpenIcon from '@icons/menu/book-open.svg';
import ChevronLeftIcon from '@icons/chevron-left.svg';
import AlarmIcon from '@icons/alarm.svg';

function NavBarItems(props) {
    const [windowSize, setWindowSize] = useState(992);
    const {navbarItemsLinks, setNavbarToggle} = props;
    const {isNorthCity, navSaleLinks, navRentLinks, defaultCity, saleLink, rentLink} = navbarItemsLinks;
    const userContext = React.useContext(UserContext);
    const userDispatcherContext = React.useContext(UserDispatcherContext);


    const northCitiesNavItemsCaptions = ['چمستان', 'نور', 'نوشهر', 'محمود آباد', 'آمل', 'رویان', 'متل قو', 'سرخ رود', 'تنکابن'];
    const northCitiesNavItemsUrl = ['چمستان', 'نور', 'نوشهر', 'محمود آباد', 'آمل', 'رویان', 'سلمانشهر ( متل قو )', 'سرخ رود', 'تنکابن ( شهسوار )'];

    const handleItemClick = (e, hasDefaultCity = false, preventDefault = false) => {
        const listTargetItem = e.target.closest('li');
        const item = e.target.closest('.dropdown-toggle');
        const allItems = item.closest('ul').children;

        /*if (preventDefault) {
            listTargetItem.querySelector('a').addEventListener('click', function (e) {
                e.preventDefault();
            },false);
        }*/


        if (!hasDefaultCity) {
            for (let i = 0; i < allItems.length; i++) {
                if (!item.contains(allItems[i])) {
                    if (listTargetItem.classList.contains('dropdown-toggle')) {
                        allItems[i].classList.remove('active');
                    }
                }
            }


            if (item.classList.contains('active')) {
                if (listTargetItem.classList.contains('dropdown-toggle')) {
                    item.classList.remove('active');
                }
            } else {
                item.classList.add('active');
            }

            if ((listTargetItem.classList.contains('dropdown-toggle')) && (listTargetItem.querySelectorAll('.inside-items').length > 0)) {
                e.preventDefault();
            } else if (!(listTargetItem.classList.contains('dropdown-toggle')) && (listTargetItem.querySelectorAll('.inside-items').length >= 0)) {
                item.classList.remove('active');
                setNavbarToggle(false);
            }
        } else {
            if ((listTargetItem.querySelectorAll('.inside-items').length <= 0)) {
                setNavbarToggle(false);
            }
        }
    };

    const setInvestModalShow = () => {
        userDispatcherContext({
            type: 'MODALITY',
            payload: {
                type: userContext.modality.type,
                city_id: userContext.modality.city_id,
                city_name: userContext.modality.city_name,
                show_invest: userContext.modality.show_invest,
                show_invest_modal: true,
                event_section: props.investmentEventSection ?? 'home',
                event_view: props.investmentEventView ?? '',
                event_position: 'navbar',
                isBadeSaba: props.isBadeSaba
            },
        })
    };

    const handleLogout = () => {
        let url = '/';
        if (!isEmpty(defaultCity)) {
            url = '/املاک-' + str_replace(' ', '-', defaultCity.name);
        }

        if (!isEmpty(url) && process.browser) {
            window.location.href = url;
        }

        userDispatcherContext({
            type: 'LOGOUT',
            payload: {},
        });
    };

    useEffect(() => {
        if (process.browser) {
            setWindowSize(window.innerWidth);
        }
    }, []);

    return (
        <ItemsContainer className={props.className ? props.className : ''}>

            {
                (userContext.check) ?
                    <LoggedIn setNavbarToggle={() => setNavbarToggle()}/>
                    : ''
            }

            <Items>

                {
                    (
                        (!isEmpty(navSaleLinks) && navSaleLinks.length && !(navSaleLinks.length === 1 && navSaleLinks[0].url === '#'))
                        || (!navSaleLinks.length && !isEmpty(defaultCity))
                        || isEmpty(defaultCity)
                        || isNorthCity
                    ) ?
                        <Item onClick={(e) => handleItemClick(e, (!navSaleLinks.length && !isNorthCity && !isEmpty(defaultCity)), isNorthCity)}
                              href={((isNorthCity && windowSize > 991) ? '/properties' : ((!navSaleLinks.length && !isEmpty(defaultCity)) ? '/properties' : '#!'))}
                              hrefAs={((isNorthCity && windowSize > 991) ? saleLink : ((!navSaleLinks.length && !isEmpty(defaultCity)) ? saleLink : '#!'))}
                              title={(isNorthCity ? 'خرید ویلا' : 'خرید خانه')}
                              crossOverLink={((!navSaleLinks.length && !isEmpty(defaultCity)) || isNorthCity) ? false : true}
                              icon={<KeyIcon/>}
                              caret={true}
                              className="dropdown-toggle">
                            {
                                (isNorthCity) ?
                                    <DropdownUl>
                                        {
                                            (isNorthCity && windowSize < 992) ?
                                                <Item
                                                    className="inside-items"
                                                    href="/properties"
                                                    hrefAs={'/املاک-شمال/خرید-فروش-ویلا'}
                                                    title={'خرید ویلا در شمال'}
                                                    crossOverLink={false}
                                                />
                                                : ''
                                        }

                                        {
                                            northCitiesNavItemsUrl.map((city, key) =>
                                                <Item
                                                    className="inside-items"
                                                    href="/properties"
                                                    hrefAs={'/املاک-' + str_replace(' ', '-', city) + '/خرید-فروش-ویلا'}
                                                    title={'خرید ویلا در ' + northCitiesNavItemsCaptions[key]}
                                                    crossOverLink={false}
                                                />
                                            )
                                        }
                                    </DropdownUl>
                                    :
                                    (
                                        (isEmpty(defaultCity)) ?
                                            <DropdownUl>
                                                <Item className="inside-items" href="/properties"
                                                      hrefAs="/املاک-شمال/خرید-فروش-ویلا" title="خرید ویلا در شمال"
                                                      crossOverLink={false}/>
                                                <Item className="inside-items" href="/properties"
                                                      hrefAs="/املاک-تهران/خرید-فروش-آپارتمان" title="خرید آپارتمان در تهران"
                                                      crossOverLink={false}/>
                                                <Item className="inside-items" href="/properties"
                                                      hrefAs="/املاک-مشهد/خرید-فروش-آپارتمان" title="خرید آپارتمان در مشهد"
                                                      crossOverLink={false}/>
                                            </DropdownUl>
                                            :
                                            (
                                                (navSaleLinks.length) ?
                                                    <DropdownUl>
                                                        {
                                                            navSaleLinks.map((link, key) =>
                                                                <Item className="inside-items" href="/properties"
                                                                      hrefAs={link.url} title={link.caption}
                                                                      crossOverLink={false}/>
                                                            )
                                                        }
                                                    </DropdownUl>
                                                    : ''
                                            )
                                    )
                            }
                        </Item>
                        : ''
                }

                {
                    (isNorthCity) ?
                        <Item onClick={(e) => handleItemClick(e, false)}
                              href={(windowSize > 991) ? '/properties' : "#!"}
                              hrefAs={(windowSize > 991) ? '/املاک-شمال/خرید-فروش-زمین' : "#!"}
                              title="خرید زمین در شمال"
                              crossOverLink={false}
                              icon={<VillaIcon/>}
                              caret={true}
                              className="dropdown-toggle"
                        >
                            <DropdownUl maxHeight="max-content">
                                {
                                    (windowSize < 992) ?
                                        <Item
                                            className="inside-items"
                                            href="/properties"
                                            hrefAs={'/املاک-شمال/خرید-فروش-زمین'}
                                            title={'خرید زمین در شمال'}
                                            crossOverLink={false}
                                        />
                                        : ''
                                }

                                {
                                    northCitiesNavItemsUrl.map((city, key) =>
                                        <Item
                                            className="inside-items"
                                            href="/properties"
                                            hrefAs={'/املاک-' + str_replace(' ', '-', city) + '/خرید-فروش-زمین'}
                                            title={'خرید زمین در ' + northCitiesNavItemsCaptions[key]}
                                            crossOverLink={false}
                                        />
                                    )
                                }
                            </DropdownUl>
                        </Item>
                        : ''
                }

                {
                    (!isNorthCity
                        && (
                            (!isEmpty(navRentLinks) && navRentLinks.length && !(navRentLinks.length === 1 && navRentLinks[0].url === '#'))
                            || (!navRentLinks.length && !isEmpty(defaultCity))
                            || isEmpty(defaultCity)
                        )
                    ) ?
                        <Item
                            onClick={(e) => handleItemClick(e, (!navRentLinks.length && !isEmpty(defaultCity)))}
                            href={((!navRentLinks.length && !isEmpty(defaultCity)) ? '/properties' : '#')}
                            hrefAs={((!navRentLinks.length && !isEmpty(defaultCity)) ? rentLink : '#')}
                            title="اجاره خانه"
                            icon={<RentIcon/>}
                            crossOverLink={(!navRentLinks.length && !isEmpty(defaultCity)) ? false : true}
                            caret={true}
                            className="dropdown-toggle">
                            {
                                (isEmpty(defaultCity)) ?
                                    <DropdownUl>
                                        <Item className="inside-items" href="/properties"
                                              hrefAs="/املاک-تهران/رهن-اجاره-آپارتمان" title="اجاره آپارتمان در تهران"
                                              crossOverLink={false}/>
                                        <Item className="inside-items" href="/properties"
                                              hrefAs="/املاک-مشهد/رهن-اجاره-آپارتمان" title="اجاره آپارتمان در مشهد"
                                              crossOverLink={false}/>
                                    </DropdownUl>
                                    :
                                    (
                                        (navRentLinks.length) ?
                                            <DropdownUl>
                                                {
                                                    navRentLinks.map((link, key) =>
                                                        <Item className="inside-items" href="/properties"
                                                              hrefAs={link.url} title={link.caption}
                                                              crossOverLink={false}/>
                                                    )
                                                }
                                            </DropdownUl>
                                            : ''
                                    )
                            }
                        </Item>
                        : ''
                }

                {
                    (!isEmpty(defaultCity)) ?
                        <Item href="/users/agencies"
                              hrefAs={'/املاک-' + str_replace(' ', '-', defaultCity.name) + '/مشاورین-املاک'}
                              title="مشاورین املاک" crossOverLink={false} icon={<PeopleIcon/>} caret={true}
                              className="dropdown-toggle"/>
                        :
                        ''
                }

                <Item href="/pages/blog"
                      hrefAs="/blog"
                      title="بلاگ ۲نبش" crossOverLink={false} icon={<BookOpenIcon/>} caret={true}
                      className="dropdown-toggle"/>

                {
                    (!userContext.check) ?
                        <Item href="/pages/services"
                              hrefAs="/خدمات-2نبش"
                              title="خدمات ۲نبش" crossOverLink={false} icon={<PeopleIcon/>} caret={true}
                              className="dropdown-toggle"/>
                        :
                        ''
                }

                {
                    ((!userContext.check || (userContext.check && !userContext.isRealtor)) && userContext.modality.show_invest && inArray(userContext.modality.city_id, [207, 262])) ?
                        (
                            (userContext.modality.city_id === 207) ?
                                <InvestmentItem title="ثبت درخواست" icon={<AlarmIcon/>} caret={true}
                                                onClick={setInvestModalShow}/>
                                :
                                (
                                    (userContext.modality.city_id === 262) ?
                                        <InvestmentItem title="سرمایه‌گذاری در گلبهار" icon={<AlarmIcon/>} caret={true}
                                                        onClick={setInvestModalShow}/>
                                        : ''
                                )
                        )
                        : ''
                }

            </Items>

            {
                (userContext.check) ?
                    <Items className="">
                        <NavbarLi className="dropdown d-lg-none logout border-0">
                            <ButtonTransparent onClick={() => handleLogout()}>
                                <Icon><ExitIcon/></Icon>
                                <span>خروج</span>
                            </ButtonTransparent>
                        </NavbarLi>
                    </Items>
                    :
                    ''
            }
        </ItemsContainer>
    )
}

export default NavBarItems;

const Item = ({href, hrefAs, title, icon, caret = false, className, linkClassName, onClick, crossOverLink = true, children}) => {

    return (
        <NavbarLi className={typeof className !== "undefined" ? className : ''} onClick={onClick}>
            {
                !crossOverLink ?
                    <Link href={href} as={hrefAs}>
                        <a className={"navbar-link " + (linkClassName ?? '')}>
                            <Icon>
                                {typeof icon !== "undefined" ? icon : ''}
                            </Icon>

                            <div className="d-flex align-items-center justify-content-between w-100">
                                <span>{title}</span>
                                {
                                    caret ?
                                        <Icon className="left-caret-icons mr-8 "><ChevronLeftIcon/></Icon>
                                        : ''
                                }
                            </div>
                        </a>
                    </Link> :
                    <a href={hrefAs} className={"navbar-link " + (linkClassName ?? '')}>
                        <Icon>
                            {typeof icon !== "undefined" ? icon : ''}
                        </Icon>

                        <div className="d-flex align-items-center justify-content-between w-100">
                            <span>{title}</span>
                            {
                                caret ?
                                    <Icon className="left-caret-icons mr-8 "><ChevronLeftIcon/></Icon>
                                    : ''
                            }
                        </div>
                    </a>
            }

            {children}
        </NavbarLi>
    )
};

const InvestmentItem = ({title, icon, caret = false, className, linkClassName, onClick, children}) => {

    return (
        <NavbarLi className={typeof className !== "undefined" ? className : ''}>

            <ButtonTransparent onClick={onClick}>
                <Icon>
                    {typeof icon !== "undefined" ? icon : ''}
                </Icon>

                <div className="d-flex align-items-center justify-content-between w-100">
                    <span>{title}</span>
                    {
                        caret ?
                            <Icon className="left-caret-icons mr-8 "><ChevronLeftIcon/></Icon>
                            : ''
                    }
                </div>
            </ButtonTransparent>

            {children}
        </NavbarLi>
    )
};

/**
 * @return {string}
 */
function LoggedIn(props) {
    const userContext = React.useContext(UserContext);
    // check auth
    const handleItemClick = (e) => {
        props.setNavbarToggle(false);
    }

    if (!userContext.isAdmin && !userContext.isRealtor) { // is normal user
        return (
            <div className="d-flex d-lg-none align-items-center">
                <Items className="w-100">
                    <Item
                        onClick={(e) => handleItemClick(e)}
                        className="logged-in-items"
                        href={{
                            pathname: '/properties',
                            query: {category: 'my_properties'},
                        }}
                        hrefAs="/properties?categories[my_properties]=on"
                        title="آگهی‌های من"
                        caret={true}
                        icon={<MyPropertyIcon/>}
                        crossOverLink={false}/>

                    {/* <Item className="logged-in-items" href="/applicants" title="درخواست‌های من" caret={true} icon={<ApplicantIcon/>} crossOverLink={false}/> */}

                    <Item
                        onClick={(e) => handleItemClick(e)}
                        className="logged-in-items"
                        href={{
                            pathname: '/properties',
                            query: {category: 'follow'},
                        }}
                        hrefAs="/properties?follow=1"
                        title="نشان‌شده‌ها"
                        caret={true}
                        icon={<BookmarkIcon/>}
                        crossOverLink={false}/>
                </Items>
            </div>
        )
    }

    return '';
}

// styles
const ItemsContainer = styled.div`
    height: 100%;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: auto;
    }
`;

export const Items = styled.ul`
    display: flex;
    align-items: center;
    
    .icons {
        width: 32px;
        height: 32px;
    }
`;

const LoginItems = styled.ul`
    display: flex;
    align-items: center;
    
    @media (min-width: ${props => props.theme.screenSmMax}) {
        display: none;
    }
    
    .icons {
        width: 32px;
        height: 32px;
    }
`;

export const DropdownUl = styled.ul`
    display: none;
    position: absolute;
    top: 79px;
    min-width: 170px;
    width: max-content;
    padding: 16px 0;
    background-color: ${props => props.theme.white};
    ${RadiusGenerate('8px')};
    box-shadow: 0 10px 37px 0 rgba(0, 0, 0, 0.15);
    z-index: 37;
    
    li {
        padding: 0 !important;
        margin: 0;
        a,button {
            display: block;
            padding: 8px 24px;
            font-size:${props => props.theme.fontSizeBase};
            line-height: 1.8;
            font-weight: normal;
            
            @media (max-width: ${props => props.theme.screenSmMax}) {
                padding-right: 0;
            }
        }
        
        &.logout {
            border-top: 1px solid ${props => props.theme.gray200};
        }
        
        &:hover {
            background-color: ${props => props.theme.gray100};
        }
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        padding-bottom: 0 !important;
    }
`;

const NavbarLi = styled.li`
    position: relative;
    margin-right: 24px;
    font-size: ${ConvertPixelToRem(15)};
    font-weight: 400;
    line-height: 1.8;
    text-align: right;
    color: ${props => props.theme.black};
    
    @media (min-width: ${props => props.theme.screenSmMax}) {
        height: 100%;
        display: flex;
        align-items: center;
        
        .icons {
            display: none;
        }
        
        &:hover {
            ${DropdownUl} {
                display: block;
            }
        }
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        flex-direction: column;
        justify-content: center;
        
        .dropdown-toggle {
            &:after {
                
            }
        }
        
        ${DropdownUl} {
            position: static;
            top: 0;
            min-width: 100%;
            box-shadow: none;
            display: block;
            opacity: 0;
            overflow: hidden;
            padding: 0;
            max-height:0;
            transition: max-height 0.4s ease, opacity .6s ease, padding .4s ease; 
        }
            
        &.active {
            //margin-top: 15px !important;
            
            ${DropdownUl} {
                max-height: 500px;
                opacity: 1;
                padding: 16px 0;
            }
            
            .left-caret-icons {
                svg {
                    transform: rotateZ(90deg);
                }
            }
        }
    }
    
    .icons {
        width: auto;
        max-width: 24px;
        height: 24px;
        
        &.left-caret-icons {
            margin-left: 0 !important;
            transition: all .4s ease; 
            width: 16px;
            height: 16px;   
            
            svg {
                path {
                    stroke-width: 1;
                }
            }
        }
    }
`;